module.exports = __webpack_public_path__ + "img/box.d7a87a14.svg";